// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3rvd3","obliqueLineWrap":"membershipbadge_obliqueLineWrap__20n3Q","obliqueLine":"membershipbadge_obliqueLine__3xYNs"};